import React from "react";
import Searchinput from "./searchinput";


class HeroSection extends React.Component {


  render() {
    return (
      <div>
        {/* start hero section */}
        <section id="hero" className="section-lg section-hero section-circle">
          {/* background circle shape */}
          <div className="shape shape-style-1 shape-primary">
            <span className="circle-150"></span>
            <span className="circle-50"></span>
            <span className="circle-50"></span>
            <span className="circle-75"></span>
            <span className="circle-100"></span>
            <span className="circle-75"></span>
            <span className="circle-50"></span>
            <span className="circle-100"></span>
            <span className="circle-50"></span>
            <span className="circle-100"></span>
          </div>
          {/* background circle shape */}
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <div className="hero-content-wrap">
                  <div className="hero-content">
                    <h1>Kehila.io</h1>
                    <p>Recherchez une association</p>
                    <Searchinput/>
                  </div>
                </div>
              </div>


            </div>
          </div>
          <div className="section-shape">
            <img src="/img/waves-shape.svg" alt="" />
          </div>
        </section>
        {/* end hero section */}
      </div>
    );
  }
}

export default HeroSection;
